import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    options: {},
    navBar: {
        policies: [],
        themes: [],
    },
};

const initSlice = createSlice({
    name: "initStore",
    initialState,
    reducers: {
        defaultOptions(state, action) {
            state.options = action.payload;
        },
        updateNavbar(state, action) {
            state.navBar.policies = action.payload.policies;
            state.navBar.themes = action.payload.themes;
        },
    },
});

export const initSliceActions = initSlice.actions;
export default initSlice.reducer;
